RivalIQ.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.Titles = Marionette.Behavior.extend({

        ui: {
            tooltips: '[data-toggle=tooltip]'
        },

        defaults: {
            atomic: false
        },

        initialize: function () {

            const me = this;
            const view = me.view;
            const loading = _.get(view, 'behaviors.Loading');
            const event = (loading ? loading.loadedEvent : 'render');
            me.listenTo(me.view, event, me.initializeTooltips);
        },

        initializeTooltips: function () {

            const me = this;
            const selector = me.getOption('selector');
            const options = _.omit(me.options, 'selector', 'atomic');
            const nodes = (selector ? me.$(selector) : me.ui.tooltips);

            if (me.getOption('atomic')) {

                nodes
                    .on('mouseenter', function () {

                        $(this)
                            .tooltip(options)
                            .tooltip('show');
                    })
                    .on('mouseleave', function () {

                        $(this)
                            .tooltip('destroy');
                    });
            } else {

                nodes.tooltip(options);
            }
        }

    });

});
